import React, { useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import { Link } from 'react-router-dom';
import { SmallButton } from 'Components/Fields/Buttons';
import { timestampToDate, formatDateRange } from 'Utils/Format';
import { CardInfo } from 'Components/CardInfo';
import PayPalInfo from 'Features/Payment/PayPalInfo';
import { ApplePayInfo } from 'Features/Payment/ApplePayInfo';
import { getDiscountDisplayName } from 'Utils/Subscriptions';

function BillingHistoryItem({ payment, invoiceRouteRoot }) {
  const { paymentID, orderProductInfo, paymentsInfo, totalTaxCharged = 0 } = payment;
  const [showDetail, onToggleDetail] = useState(false);
  const productInfoItem = orderProductInfo.find((o) => o.appId);
  const { displayName, startDate, endDate, retailPrice } = productInfoItem;
  const { hasDiscounts, discountsDesc, discountsAmount, parentDisplayName } = getDiscountDisplayName(productInfoItem);

  const [{ receivedDate = 0, cardType, creditCardNumber, amount, paymentType, email = '', applePayID = '' }] =
    paymentsInfo;
  const totalCharged = amount < 0 ? `-$${(amount * -1).toFixed(2)}` : `$${amount.toFixed(2)}`;
  const billDate = timestampToDate(receivedDate, 2);
  const billingPeriod = formatDateRange(startDate, endDate);

  return (
    <li className="billingListItem">
      <button className="sectionFlex billingSummary" role="button" onClick={() => onToggleDetail(!showDetail)}>
        <span className="firstCol">{billDate}</span>
        <span className="secondCol">{parentDisplayName}</span>
        <span className="thirdCol">{billingPeriod}</span>
        <span className="fourCol">
          <span className="listPrice">{totalCharged}</span>
          <i className={`arrow ${showDetail ? 'upArrow' : 'downArrow'}`} />
        </span>
        <Link className="viewLink" to={`${invoiceRouteRoot}/${paymentID}`}>
          <SmallButton text="View" />
        </Link>
      </button>

      {showDetail && (
        <div className="paymentDetail">
          {retailPrice && (
            <div className="sectionFlex paymentDetailItem">
              <span className="detailLabel">{displayName}</span>
              <span className="detailPrice">${retailPrice.toFixed(2)}</span>
            </div>
          )}
          <div className="sectionFlex paymentDetailItem">
            <span className="detailLabel">Tax</span>
            <span className="detailPrice">${totalTaxCharged.toFixed(2)}</span>
          </div>
          {hasDiscounts && discountsAmount > 0 && (
            <div className="sectionFlex paymentDetailItem">
              <span className="detailLabel">{discountsDesc}</span>
              <span className="detailPrice">{`-$${discountsAmount.toFixed(2)}`}</span>
            </div>
          )}
          {paymentType === 'Credit/Debit Card' && (
            <div className="sectionFlex paymentDetailItem">
              <CardInfo cardNumber={creditCardNumber} cardType={cardType} />
            </div>
          )}
          {paymentType === 'PayPal Account' && (
            <div className="sectionFlex paymentDetailItem">
              <PayPalInfo email={email} />
            </div>
          )}
          {paymentType === 'ApplePay' && (
            <div className="sectionFlex paymentDetailItem">
              <ApplePayInfo applePayID={applePayID} />
            </div>
          )}
        </div>
      )}
    </li>
  );
}

export default BillingHistoryItem;
